module.exports = __webpack_public_path__ + "static/media/cxj_banner_five.865cb121.png";